import React, { createContext, useState } from "react";
import MapboxGl from "mapbox-gl";
import { Feature } from "geojson";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import { categoryLayers } from "../constant/roles";

interface IDrawEvent {
  type:
    | "equip-pole"
    | "equip-cable"
    | "equip-relay"
    | "equip-transformer"
    | "equip-switch"
    | "equip-meter"
    | "equip-riser-transformer"
    | "anno-label"
    | "measure-area"
    | "measure-length"
    | "anno-shape-rectangle"
    | "anno-shape-circle"
    | "anno-shape-stroke"
    | "cad"
    | "info"
    | undefined;
  feature?: Feature;
  designEquips: any;
  anno?: any;
}

interface ICad {
  file_name: string;
  url: string;
  bbox: [
    [number, number],
    [number, number],
    [number, number],
    [number, number]
  ];
  rotate: number;
  visible: boolean;
}

interface IDesignContext {
  map: MapboxGl.Map | undefined;
  stylemap: MapboxGl.Style | undefined;
  event: IDrawEvent;
  electrictLayers: any;
  administrativeLayers: any;
  basemap: "openmaptiles" | "mea-ortho" | "nostra";
  cad: ICad[];
  orbitgt?: any;
  status: 0 | 1 | 2;
  setmap: Function;
  setstylemap: Function;
  setevent: Function;
  setelectrictLayers: Function;
  setadministrativeLayers: Function;
  setbasemap: Function;
  setcad: Function;
  setorbitgt: Function;
  setstatus: Function;
}

const initalState: IDesignContext = {
  map: undefined,
  stylemap: undefined,
  event: { type: undefined, designEquips: [] },
  electrictLayers: undefined,
  administrativeLayers: undefined,
  basemap: "openmaptiles",
  cad: [],
  orbitgt: undefined,
  status: 0,
  setmap: () => {},
  setstylemap: () => {},
  setevent: () => {},
  setelectrictLayers: () => {},
  setadministrativeLayers: () => {},
  setbasemap: () => {},
  setcad: () => {},
  setorbitgt: () => {},
  setstatus: () => {},
};

export const DesignContext = createContext<IDesignContext>(initalState);
export const DesignContextProvider = (props: any) => {
  const [map, setmap] = useState<MapboxGl.Map | undefined>(undefined);
  const [stylemap, setstylemap] = useState<MapboxGl.Style | undefined>(
    undefined
  );
  const [event, setevent] = useState<IDrawEvent>(initalState.event);
  const [electrictLayers, setelectrictLayers] = useState<
    typeof categoryLayers | undefined
  >(undefined);
  const [administrativeLayers, setadministrativeLayers] = useState<any>(
    undefined
  );

  const [basemap, setbasemap] = useState<IDesignContext["basemap"]>(
    initalState.basemap
  );
  const [cad, setcad] = useState<IDesignContext["cad"]>(initalState.cad);
  const [orbitgt, setorbitgt] = useState<IDesignContext["orbitgt"]>(
    initalState.orbitgt
  );

  const [status, setstatus] = useState<IDesignContext["status"]>(
    initalState.status
  );

  return (
    <DesignContext.Provider
      value={{
        map,
        stylemap,
        event,
        electrictLayers,
        administrativeLayers,
        basemap,
        cad,
        orbitgt,
        status,
        setmap,
        setstylemap,
        setevent,
        setelectrictLayers,
        setadministrativeLayers,
        setbasemap,
        setcad,
        setorbitgt,
        setstatus,
      }}
    >
      {props.children}
    </DesignContext.Provider>
  );
};
export const DesignContextConsumer = DesignContext.Consumer;
